import PubSub from 'pubsub-js';
// import WebFont from 'webfontloader';
import { Logger } from '../utils/logger';

import './page.scss';

const COMPONENT_NAME = 'tcl-page';
const EVENT_KEY = COMPONENT_NAME;

export const PageEvents = {
  PAGE_READY: `${EVENT_KEY}.pageReady`,
};

/**
 * version    1.0
 * class      <type> (Page)
 * classdesc  Component representing the whole Page (down from html)
 */
export class Page {
  constructor() {
    this._isPageReady = false;
    this._findUIElements();
    this._bindEvents();
    this._initUI();
  }

  // private methods

  _findUIElements() {
    this._els = {
      html: $('html'),
      body: $('body'),
    };
  }

  _bindEvents() {
    // component events
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._isPageReady = true;
      this._els.body.addClass('tcl-page--is-ready');

      $(window).on('load', () => {
        this._initScrollToFragment();
      });
    });
  }

  _initUI() {
    this._initBackgroundColors();
    this._initTextColors();
    this._initButtons();

    // on webfont loaded
    // WebFont.load({
    //   active: () => {
    //     PubSub.publish(PageEvents.PAGE_READY);
    //   },
    //   google: {
    //     families: [
    //       'Montserrat:200,300,300i,500,700',
    //       'EB+Garamond',
    //     ],
    //   },
    // });
    PubSub.publish(PageEvents.PAGE_READY);
  }

  // set text color as specified via data attribute
  _initBackgroundColors($container = $('body')) {
    $container.find('[data-bg-color]').each(function () {
      $(this).css('background-color', $(this).data('bg-color'));
    });
  }

  // set text color as specified via data attribute
  _initTextColors($container = $('body')) {
    $container.find('[data-text-color]').each(function () {
      const colorValue = $(this).data('text-color');
      if (colorValue && colorValue.startsWith('#')) {
        $(this).css('color', colorValue);
      }
    });
  }

  _initButtons($container = $('body')) {
    $container.find('[data-btn-icon]').each(function () {
      const $btn = $(this);
      if ($btn.find('.svg-icon').length === 0) {
        const iconName = $btn.attr('data-btn-icon');
        const flip = $btn[0].hasAttribute('data-btn-icon-flip');
        const icon = `<svg role="img" class="svg-icon svg-icon--${iconName}" aria-hidden="true"><use xlink:href="#sprite-${iconName}"></use></svg>`;
        if (flip) {
          $btn.prepend(icon);
        } else {
          $btn.append(icon);
        }
      }
    });
  }

  _initScrollToFragment() {
    if (window.location.hash) {
      const $el = $(window.location.hash);
      if ($el.length > 0) {
        const headerHeight = 80;
        const elementTopPos = $el.offset().top;
        Logger.log('adjusting page scroll top to fragment element');
        $('html, body').animate({
          scrollTop: elementTopPos - headerHeight,
        }, 500);
      }
    }
  }

  // public methods

  isPageReady() {
    return this._isPageReady;
  }
}
